/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

export interface ISummaryDetailMethods extends IPluginMethodMap {
  getSummaryDetailProps(args: any): Promise<any>;
}

export class SummaryDetailService implements IAgentPlugin {
  readonly methods: ISummaryDetailMethods;

  constructor() {
    this.methods = {
      getSummaryDetailProps: this.getSummaryDetailProps.bind(this),
    };
  }

  async getSummaryDetailProps(args: any) {
    try {
      // Mock datasets from mockup screenshot
      const defaultData = [
        { id: "1", costumeOption: "Individual Head Fee", inventory: 1, assigned: 1, remaining: 0 },
        { id: "2", costumeOption: "Male", inventory: 1051, assigned: 1162, remaining: -111 },
        { id: "3", costumeOption: "Female Option 2", inventory: 359, assigned: 335, remaining: 24 },
        { id: "4", costumeOption: "Female", inventory: 1384, assigned: 1609, remaining: -225 },
        { id: "5", costumeOption: "Individual", inventory: 0, assigned: 0, remaining: 0 },
      ];

      const specialReserveData = [
        { id: "1", costumeOption: "Individual Head Fee", inventory: 0, assigned: 0, remaining: 0 },
        { id: "2", costumeOption: "Male", inventory: 29, assigned: 64, remaining: -35 },
        { id: "3", costumeOption: "Female Option 2", inventory: 27, assigned: 26, remaining: 1 },
        { id: "4", costumeOption: "Female", inventory: 33, assigned: 69, remaining: -36 },
        { id: "5", costumeOption: "Individual", inventory: 0, assigned: 0, remaining: 0 },
      ];

      const sectionSpecificData = [
        { id: "1", costumeOption: "Individual Head Fee", inventory: 10, assigned: 1, remaining: 9 },
        { id: "2", costumeOption: "Male", inventory: 807, assigned: 825, remaining: -18 },
        { id: "3", costumeOption: "Female Option 2", inventory: 702, assigned: 744, remaining: -42 },
        { id: "4", costumeOption: "Female", inventory: 1262, assigned: 1317, remaining: -55 },
        { id: "5", costumeOption: "Individual", inventory: 1, assigned: 2, remaining: -1 },
      ];

      return {
        defaultData,
        specialReserveData,
        sectionSpecificData,
      };
    } catch (err: any) {
      console.log(`error in getSummaryDetailProps`, err);
      return {
        defaultData: [],
        specialReserveData: [],
        sectionSpecificData: [],
      };
    }
  }
}
